const alphabet = '23456789ABDEGJKMNPQRVWXYZ';

export const generateId = (length = 6): string => {
	let id = '';

	for (let i = 0; i < length; i++) {
		id += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
	}

	return id;
};
